import styles from "./ShareButton.module.css";
import { IoShareSocial } from "react-icons/io5";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  EmailIcon,
  FacebookIcon,
  XIcon,
  LinkedinIcon,
  WhatsappIcon,
} from "react-share";
import { useDropdown } from "../../hooks/useDropdown";
import { useCallback } from "react";

const ShareButton = ({ product, shareUrl }) => {
  const {
    elementRef: shareButtonRef,
    expanded: shareButtonIsOpen,
    setExpanded: setShareButtonIsOpen,
    triggerRef: shareButtonTriggerRef,
  } = useDropdown();

  const handleShareTriggerClick = useCallback(() => {
    setShareButtonIsOpen((isOpen) => !isOpen);
  }, [setShareButtonIsOpen]);

  const email_body = `Hey, Checkout this amazing product ${product.name}.`;

  return (
    <>
      <div className={styles.productshareIcon} ref={shareButtonTriggerRef}>
        <button onClick={handleShareTriggerClick}>
          <IoShareSocial size={25} />
        </button>
      </div>
      <div>
        {shareButtonIsOpen ? (
          <div className={`${styles.shareTooltip}`} ref={shareButtonRef}>
            <FacebookShareButton
              url={shareUrl}
              quote={`Share ${product.name}`}
              description={"facebook"}
            >
              <FacebookIcon size={30} round />
            </FacebookShareButton>

            <TwitterShareButton title={`Share ${product.name}`} url={shareUrl}>
              <XIcon size={30} round />
            </TwitterShareButton>

            <WhatsappShareButton
              title={`Share ${product.name}`}
              url={shareUrl}
              separator="! "
              description={"whatsapp"}
            >
              <WhatsappIcon size={30} round />
            </WhatsappShareButton>
            <LinkedinShareButton
              title={`Share ${product.name}`}
              url={shareUrl}
              separator="! "
              description={"linkedIn"}
            >
              <LinkedinIcon size={30} round />
            </LinkedinShareButton>

            <EmailShareButton
              subject={`Share ${product.name}`}
              url={shareUrl}
              body={email_body}
              separator=" "
            >
              <EmailIcon size={30} round />
            </EmailShareButton>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default ShareButton;
